import api from "./api/api";

const CUSTOM_ALERT_API = '/api/custom-alert';

// Create a new custom alert
export const createCustomAlert = async (customAlertData) => {
    try {
        const response = await api.post(`${CUSTOM_ALERT_API}`, customAlertData);
        return response;
    } catch (error) {
        console.error('Error creating custom alert:', error);
        throw error;
    }
};

// Get all custom alerts
export const getCustomAlerts = async (params = {}) => {
    try {
        const response = await api.get(`${CUSTOM_ALERT_API}`, { params });
        return response;
    } catch (error) {
        console.error('Error getting custom alerts:', error);
        throw error;
    }
};

// Update a custom alert
export const updateCustomAlert = async (customAlertId, updateData) => {
    try {
        const response = await api.put(`${CUSTOM_ALERT_API}/${customAlertId}`, updateData);
        return response;
    } catch (error) {
        console.error('Error updating custom alert:', error);
        throw error;
    }
};

// Delete a custom alert
export const deleteCustomAlert = async (customAlertId) => {
    try {
        const response = await api.delete(`${CUSTOM_ALERT_API}/${customAlertId}`);
        return response;
    } catch (error) {
        console.error('Error deleting custom alert:', error);
        throw error;
    }
};

// Toggle facility for custom alert
export const toggleCustomAlertFacility = async (customAlertId, facilityId, enabled) => {
    try {
        const response = await api.post(`${CUSTOM_ALERT_API}/toggle-facility`, {
            customAlertId,
            facilityId,
            enabled
        });
        return response;
    } catch (error) {
        console.error('Error toggling custom alert facility:', error);
        throw error;
    }
};

// Toggle facility for shared custom alert
export const toggleSharedCustomAlertFacility = async (customAlertId, facilityId, enabled) => {
    try {
        const response = await api.post(`${CUSTOM_ALERT_API}/toggle-shared-facility`, {
            customAlertId,
            facilityId,
            enabled
        });
        return response;
    } catch (error) {
        console.error('Error toggling shared custom alert facility:', error);
        throw error;
    }
}; 